import * as React from "react";
import "./flaggedemail.scss";
import { OutlookEmailobj } from "../../Entity/OutlookEmailobj";
import FlaggedEmailItem from './FlagEmailItem';

export interface Props {
  flaggedemails: OutlookEmailobj[];
  UpdateMethod;
  Phrases;
  taskfromflagemail;
  usertimezone;
}
export default class FlaggedEmailItemList extends React.Component<Props> {
  constructor(props) {
    super(props);
  }
  public componentDidMount() {}
  public render() {
    return (
      <div className="flaggedemail">
        {this.props.flaggedemails.map((emailobj, index) => {
          return (
            <FlaggedEmailItem
              flaggedemail={emailobj}
              key={emailobj.id}
              UpdateMethod={this.props.UpdateMethod}
              Phrases={this.props.Phrases}
              taskfromflagemail={this.props.taskfromflagemail}
              usertimezone={this.props.usertimezone}
            />
          );
        })}
      </div>
    );
  }
}
